import axios from '@/api';

export default {
  async saveSteps({ getters, dispatch }, steps) {
    const id = getters.getId;
    const segment = getters.getSegment;
    const application = {
      items: [
        {
          segment,
          steps: steps,
        },
      ],
    };

    if (id) await dispatch('updateApplication', { id, application });
    else await dispatch('createApplication', { application });

    return id;
  },
  async createApplication({ commit, rootGetters }, { application }) {
    const id = await axios
      .post('supplierapplications', application, {
        headers: { recaptcha: rootGetters['getGoogleVerifyKey'] },
      })
      .then(response => response.data)
      .then(response =>
        response.items.length > 0 ? response.items[0].id : null
      );

    commit('setId', id);

    return id;
  },
  async updateApplication(context, { id, application }) {
    await axios.put(`supplierapplications/${id}`, application);
    return id;
  },
  async fetchApplication({ commit }, id) {
    return await axios
      .get(`supplierapplications/${id}`)
      .then(response => response.data)
      .then(response => (response.items.length > 0 ? response.items[0] : null))
      .then(response => {
        if (response) {
          commit('setApplication', response);
        }
        return response;
      });
  },
  async checkEmailIsUse(content, { email }) {
    return await axios
      .post('lookup/suppliers/email', {
        items: [
          {
            email: email,
          },
        ],
      })
      .then(response => response.data)
      .then(response => response.items[0].inUse);
  },
};
